﻿/**
 * A dropdown consists of a toggle button and a panel.
 * <div>
 *   <button data-js-dropdown aria-controls="panel-id" aria-expanded="false" />
 *   <div id="panel-id" data-dropdown-direction="down" class="hidden" />
 * </div>
 *
 * The button and panel have the following data attributes,
 * use these to control the visibility of the panel for example:
 * data-open-classes="css-class-to-use-when-expanded other-class"
 * data-closed-classes="css-class-to-use-when-collapsed third-class"
 */

import { initializeDropdown } from "./dropdown-handlers";

document
  .querySelectorAll("[data-js-dropdown]:not([data-js-dropdown-disable-auto-init='true'])")
  .forEach(initializeDropdown);
